<template>
  <div>
    <div v-if="isLoading" class="loading" />
    <b-modal
      v-else
      id="modal_wallet"
      ref="modal_wallet"
      modal-class="modal_wallet modal_wallet-border"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      footer-class="modal-footer justify-content-center border-top-0"
      header-class="modal-header justify-content-center align-items-center border-bottom-0"
      dialog-class="modal-dialog modal-dialog-centered modal-md"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ $t('Bao.transfer_amount') }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" @click="hideModal">
          <i class="icon-clear" />
        </button>
      </template>
      <template v-slot:modal-footer>
        <div class="wallet_transfer_btn modal_btns d-flex justify-content-center w-100">
          <button class="btn btn_transfer text-white" type="button" :disabled="actionLoading" @click="transferAllSubmit">
            {{ oneClickLabel }}
            <i
              v-show="actionLoading"
              class="fa fa-spinner fa-pulse fa-fw"
            />
          </button>
          <button class="btn btn_immediately" type="button" :disabled="actionLoading" @click="transferSubmit">
            {{ $t('Bao.transfer_now') }}
            <i
              v-show="actionLoading"
              class="fa fa-spinner fa-pulse fa-fw"
            />
          </button>
        </div>
      </template>
      <div class="wallet_transfer_area d-grid">
        <h6 class="wallet_transfer_tips text-center mb-0">
          {{ $t('Bao.game_wallet_transfer_notice') }}
        </h6>
        <ul class="wallet_transfer_inner d-grid align-items-center list-unstyled mb-0">
          <li class="align-self-start">
            <div class="wallet_transfer_block left">
              <h5 :class="'wallet_slt wallet_name text-center w-100 ' + (transferForm.type === 'out'?'active':'')">
                {{ $t('Bao.main_wallet') }}
              </h5>
              <ul class="wallet_transfer_list d-grid list-unstyled mb-0">
                <li>
                  <div class="wallet_transfer_money d-flex align-items-center justify-content-between">
                    <h6 class="mb-0">
                      {{ $t('Bao.main_wallet_balance') }}
                    </h6>
                    <!--eslint-disable-next-line -->
                    <b v-html="$options.filters['numberFormat']($store.getters.commonGold)"></b>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div v-if="modalParams.fixType === 'in'" class="wallet_transfer_block middle">
              <label class="arrow_lab mb-0" />
            </div>
            <div v-else class="wallet_transfer_block middle">
              <input id="arrow_change" :class="transferTypeClass" type="checkbox">
              <label class="arrow_lab mb-0" for="arrow_change" @click="toggleTransferType()" />
            </div>
          </li>
          <li class="align-self-start">
            <div class="wallet_transfer_block right">
              <div class="position-relative">
                <div class="wallet_slt_area position-relative">
                  <select
                    v-model="transferForm.game_provider_id"
                    :disabled="modalParams.fixType"
                    :class="'wallet_slt wallet_name text-center w-100 ' + (transferForm.type === 'in'?'active':'')"
                    @change="handleProvider($event)"
                  >
                    <template v-for="(item, keyData) in $store.getters.gameBalance">
                      <template v-if="item">
                        <option :key="keyData" :value="item.game_provider_id">
                          {{ item.game_provider_name }}
                        </option>
                      </template>
                    </template>
                  </select>
                </div>
              </div>
              <ul class="wallet_transfer_list d-grid list-unstyled mb-0">
                <li>
                  <div class="wallet_transfer_money d-flex align-items-center justify-content-between">
                    <h6 class="mb-0">
                      {{ $t('Bao.game_wallet_balance') }}
                    </h6>
                    <p v-if="selectedProvider" class="mb-0">
                      {{ selectedProvider.amount | numberFormat }}
                    </p>
                  </div>
                </li>
                <li>
                  <div class="wallet_transfer_money d-flex align-items-center justify-content-between">
                    <h6 class="mb-0">
                      {{ $t('Bao.withdrawal_limit') }}
                    </h6>
                    <p v-if="selectedProvider" class="mb-0">
                      {{ selectedProvider.withdrawal_limit | numberFormat }}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div class="wallet_transfer_form d-grid align-items-center">
          <h5 class="mb-0">
            <b>{{ $t('Bao.transfer_amount') }}</b>
          </h5>
          <div class="wallet_transfer_form_inner d-flex position-relative">
            <input
              v-model="transferForm.amount"
              v-validate="'required|integer|between:1,'+maxAmount"
              class="wallet_transfer_input"
              :placeholder="$t('Bao.please_input_transfer_amount')"
              type="text"
              required
              name="amount"
              :data-vv-as="$t('Bao.transfer_amount')"
              autocomplete="off"
            >
            <button class="wallet_transfer_point btn border-0 d-flex position-absolute p-0 mb-0" type="button" @click="setMax">
              {{ $t('Bao.max_amount') }}
            </button>
          </div>
          <span />
          <small v-visible="errors.has('amount')" class="help-block pull-right" style="min-height: 14px;">{{ maxAmount > 0 ? errors.first('amount') : $t('Bao.min_transfer_amount_notice') }}</small>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { deposit, withdrawal, oneGameBalance } from '@/api/game'
import { hideGameWalletModal } from '@/utils/games'
import { showNotice } from '@/utils/tool'

export default {
  name: 'GameWalletTransfer',
  data() {
    return {
      isLoading: false,
      transferForm: {
        type: 'in',
        game_provider_id: this.$store.getters.showGameWalletModal,
        amount: null
      },
      actionLoading: false
    }
  },
  computed: {
    transferTypeClass() {
      if (this.transferForm.type === 'in') {
        return 'arrow_ipt d-none'
      } else {
        return 'arrow_ipt d-none checked'
      }
    },
    oneClickLabel() {
      if (this.transferForm.type === 'in') {
        return this.$t('Bao.deposit_game_all')
      } else {
        return this.$t('Bao.leave_game_all')
      }
    },
    selectedProvider() {
      return this.$store.getters.gameBalance[this.transferForm.game_provider_id]
    },
    modalParams() {
      return this.$store.getters.showGameWalletModal
    },
    showModelProviderId() {
      return this.$store.getters.showGameWalletModal.gameProviderId
    },
    maxAmount() {
      if (this.transferForm.type === 'in') {
        return parseInt(this.$store.getters.commonGold)
      } else {
        return parseInt(this.selectedProvider.amount)
      }
    }
  },
  watch: {
    showModelProviderId(newVal, oldVal) {
      if (!newVal) {
        this.hideModal()
      } else {
        this.showModal(newVal)
      }
    }
  },
  mounted() {
    this.showModal(this.modalParams.gameProviderId)
  },
  methods: {
    showModal(gameProviderId) {
      this.transferForm.type = 'in'
      this.transferForm.game_provider_id = gameProviderId
      this.transferForm.amount = this.maxAmount

      const self = this
      const current = Object.fromEntries(Object.entries(this.$store.getters.gameBalance).filter(([_, v]) => v != null))
      if (current[gameProviderId] === undefined) {
        // 沒資料查詢
        oneGameBalance({ game_provider_id: gameProviderId }).then((response) => {
          const gameBalance = response.data.data
          current[gameBalance.game_provider_id] = gameBalance
          this.$store.commit('SET_GAME_BALANCE_INFO', current)

          this.$bvModal.show('modal_wallet')
        }).catch(() => {
        }).finally(function() {
          self.isLoading = false
        })
      } else {
        // 已有資料
        this.$bvModal.show('modal_wallet')
      }
    },
    hideModal() {
      this.$bvModal.hide('modal_wallet')
      hideGameWalletModal()
    },
    setMax() {
      this.transferForm.amount = this.maxAmount
    },
    handleProvider(event) {
      this.transferForm.game_provider_id = event.target.value
    },
    toggleTransferType() {
      if (this.modalParams.fixType) {
        this.transferForm.type = this.modalParams.fixType
      } else {
        if (this.transferForm.type === 'in') {
          this.transferForm.type = 'out'
        } else {
          this.transferForm.type = 'in'
        }

        this.$nextTick(function() {
          this.transferForm.amount = this.maxAmount
        })
      }
    },
    transferAllSubmit() {
      this.setMax()
      this.transferSubmit()
    },
    transferSubmit() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.$store.commit('SET_LOADING', true)
          this.actionLoading = true

          const self = this
          const current = this.$store.getters.gameBalance
          if (this.transferForm.type === 'in') {
            // 轉入
            deposit(this.transferForm)
              .then((response) => {
                const gameBalance = response.data.data
                current[gameBalance.game_provider_id] = gameBalance
                this.$store.commit('SET_GAME_BALANCE_INFO', current)

                const func = this.modalParams.callback
                if (func !== undefined && typeof func === 'function') {
                  func()
                } else {
                  showNotice(this.$t('Bao.transfer_success'))
                }
                self.hideModal()
              })
              .catch((error) => {
                showNotice(error.response.data.msg)
              })
              .finally(() => {
                this.$store.commit('SET_LOADING', false)
                this.actionLoading = false
              })
          } else {
            // 轉出
            withdrawal(this.transferForm)
              .then((response) => {
                const gameBalance = response.data.data
                current[gameBalance.game_provider_id] = gameBalance
                this.$store.commit('SET_GAME_BALANCE_INFO', current)

                const func = this.modalParams.callback
                if (func !== undefined && typeof func === 'function') {
                  func()
                } else {
                  showNotice(this.$t('Bao.transfer_success'))
                }
                self.hideModal()
              })
              .catch((error) => {
                showNotice(error.response.data.msg)
              })
              .finally(() => {
                this.$store.commit('SET_LOADING', false)
                this.actionLoading = false
              })
          }
        }
      })
    }
  }
}
</script>
